import React, { Component } from 'react'
import { 
  Button, ButtonGroup, Popover,
  Menu, MenuItem, Position
} from '@blueprintjs/core';
import { action } from 'mobx';
import { observer, inject } from 'mobx-react';
import SearchFiltersToolbar from 'components/SearchFiltersToolbar';
import SearchFiltersSearchButton from 'components/SearchFiltersSearchButton';

@inject('store', 'viewStore') @observer
class ServiceType extends Component {

  @action
  search() {
    let viewStore = this.props.viewStore;
    viewStore.serviceTypeSearch.page = 1;
    this.props.viewStore.serviceTypes();
  }

  @action
  onSearchTermChange(e) {
    
    let {
      props: {
        viewStore: {
          serviceTypeSearch
        }
      }
    } = this;
    this.props.viewStore.serviceTypeSearch = {
      ...serviceTypeSearch,
      term: e.target.value
    }
  }

  onEnter(event) {
    if (event.key === "Enter") {
      this.search()
    }
  }

  render() {
    let {
      props: {
        store,
        viewStore,
        viewStore: {
          serviceTypeSearch: { term }
        }
      }
    } = this;
    if(term == '*'){
      term = '';
    }
    return (
      <SearchFiltersToolbar
        searchButton={
          <SearchFiltersSearchButton onClick={this.search.bind(this)} />
        }
        actions={
          <Button icon={'plus'} small={true} onClick={() =>  store.isOpenAddServiceTypeDialog = true }>
            Add Service Type
          </Button>
        }
      >
        <input
          type="text"
          className="bp3-input search-filters-toolbar__field-wide"
          placeholder="Name, Description"
          onChange={this.onSearchTermChange.bind(this)}
          defaultValue={term}
          onKeyPress={this.onEnter.bind(this)}
        />
      </SearchFiltersToolbar>
    )
  }
}

export default ServiceType;